import React from 'react'

import { Col, Form } from '_zari/core'

import * as TurnoService from 'services/turno.service'

import { PartesDiaTurno } from 'constants/index'

const TurnoPage = ({ turnos, setTurnos, turnoSeleccionado, setTurnoSeleccionado, usuarioSeleccionado }) => {
  React.useEffect(() => {
    TurnoService.obtenerxIdUsuarioAsSelect(usuarioSeleccionado).then(({ data }) => {
      setTurnos(data)
    })
  }, [setTurnos, usuarioSeleccionado])

  return (
    <>
      <Form.Group>
        <Form.Label text='TURNO' htmlFor='select-turno' md={3} />
        <Col md={6}>
          <Form.Select
            disabled={!usuarioSeleccionado}
            name='selectTurno'
            id='select-turno'
            value={turnoSeleccionado}
            onChange={e => setTurnoSeleccionado(e.target.value)}
          >
            <option value=''>Todos</option>
            {turnos.map((x, k) => (
              <option key={k} value={x._id}>
                {x.fechaInicio} - {PartesDiaTurno.__dictionary[x.parteDia].nombre}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Form.Group>
    </>
  )
}

export default TurnoPage
